import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, Mail, Shield, Award } from 'lucide-react';
import './CTASection.css';

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="cta-background-pattern">
        <div className="cta-pattern-overlay"></div>
      </div>
      
      <div className="container-custom relative z-10">
        <div className="cta-content">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="cta-text-content"
          >
            <h2 className="cta-title">
              Ready to Optimize Your{' '}
              <span className="cta-title-highlight">Flow Control Systems?</span>
            </h2>
            <p className="cta-description">
              Get expert consultation, free quotes, and 24/7 support for all your valve and actuator needs.
              Our certified technicians are ready to help you maintain peak performance.
            </p>
            
            <div className="cta-buttons">
              <Link to="/contact" className="cta-primary-button">
                Get Free Quote
                <ArrowRight className="w-5 h-5 ml-2" />
              </Link>
              <a href="tel:+918329392431" className="cta-secondary-button">
                <Phone className="w-5 h-5 mr-2" />
                Call Now
              </a>
            </div>
            
            <div className="cta-contact-info">
              <div className="cta-contact-item">
                <Mail className="w-5 h-5 text-primary-400" />
                <a href="mailto:kirbooindia@gmail.com" className="hover:underline">
                  kirbooindia@gmail.com
                </a>
              </div>
              <div className="cta-contact-item">
                <Phone className="w-5 h-5 text-primary-400" />
                <a href="tel:+918329392431" className="hover:underline">
                  +91 8329392431
                </a>
              </div>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="cta-visual-content"
          >
            <div className="cta-visual-card">
              <div className="cta-visual-icon">
                <div className="cta-icon-wrapper">
                  <Shield className="w-8 h-8 text-white" />
                </div>
              </div>
              <h3 className="cta-visual-title">24/7 Emergency Support</h3>
              <p className="cta-visual-description">
                Round-the-clock technical assistance for critical system failures
              </p>
            </div>
            
            <div className="cta-visual-card">
              <div className="cta-visual-icon">
                <div className="cta-icon-wrapper">
                  <Award className="w-8 h-8 text-white" />
                </div>
              </div>
              <h3 className="cta-visual-title">Certified Technicians</h3>
              <p className="cta-visual-description">
                Factory-trained experts with years of industry experience
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;

